<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managerolecompany/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
